import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
const testimonials = [{
  author: "Marcus T.",
  quote: "FocusPath brought the same rigor they used for our Global 500 division to our mid-market operations, making AI adoption seamless.",
  position: "COO, Innovate Logistics",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/avatar_jane_d.png"
}, {
  author: "Elena R.",
  quote: "Their 40 years of expertise is evident in every recommendation. They didn't just give us tools; they transformed our entire process.",
  position: "Founder, TechFlow Systems",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/avatar_john_s.png"
}, {
  author: "David K.",
  quote: "The transition to agentic workflows felt natural under FocusPath's guidance. Our efficiency metrics have never looked better.",
  position: "Director of Ops, Nexus Retail",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/avatar_sarah_l.png"
}];
export default function SuccessStories() {
  return;
}